// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_50-2";
export var blackBorderOnHover = "_50-7";
export var cell = "_50-6";
export var cellContainer = "_50-3";
export var checked = "_50-8";
export var disabled = "_50-5";
export var featuredIconCellContainer = "_50-9";
export var featuredIconTextContainer = "_50-b";
export var featuredIconWrapper = "_50-a";
export var noBorder = "_50-c";
export var orangeSelectedRow = "_c2-3";
export var overflowableText = "_50-0";
export var overflowableTextContainer = "_50-1";
export var row = "_52-0";
export var rowCheckboxCell = "_50-4";
export var selectableTable = "_c2-2";